import { render } from "./Dashboard.vue?vue&type=template&id=d7198376&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=d7198376&scoped=true&lang=css"

import exportComponent from "/kaam/build/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7198376"]])

export default __exports__